export default "__VITE_ASSET__BcXEiAda__"